import { CookiesName } from '@/api';
import { useCookies } from 'vue3-cookies';
import { TLoginApiResponse } from '@/types/users/index';
import { useTemplateRef } from 'vue'
import { storeToRefs } from 'pinia'
import { useAdminStore } from '@/stores/admin'
import { Permission } from '@/constants/users/permission'

const { cookies } = useCookies();

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(v) || 'Please enter a valid email address';
  },
  password: (v: string) => {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{8,64}$/;
    return pattern.test(v) || 'Пароль должен содержать минимум 8 символов, хотя бы одну заглавную букву, одну строчную букву, одну цифру и один специальный символ.';
  },
  arrayHasItems: (v: any) => !!v && Array.isArray(v) && v?.length > 0 || 'This field is required',
  required: (v: any) => !!v || 'This field is required',
  minLength: (v: any, length: number) => v?.length >= length || `Минимальная длина поля ${length} символов`,
  maxLength: (v: any, length: number) => v.length <= length || `Максимальная длина поля ${length} символов`,
};

export const setAllCookies = (response: TLoginApiResponse) => {
  cookies.set(CookiesName.token, response.accessToken);
  cookies.set(CookiesName.refreshToken, response.refreshToken);
};

export const removeAllCookies = () => {
  cookies.remove(CookiesName.token);
  cookies.remove(CookiesName.refreshToken);
};

export const tokenIsValid = () => {
  const token = cookies.get(CookiesName.token);
  return !!token;
};

export const refreshTokenIsValid = () => {
  const token = cookies.get(CookiesName.refreshToken);
  return !!token;
};

export const useMultipleTemplateRefs = (names: string[]) => {
  return names.map((name) => useTemplateRef(name))
}

const rolePermissionsFallback: Record<string, string[]> = {
  Marketolog: [
    Permission.ADMINS_NICKNAME_VIEW,
    Permission.ADMINS_USERID_VIEW,
    Permission.APP_USERS_USERID_VIEW,
    Permission.APP_USERS_REGISTRATION_DATE_VIEW,
    Permission.APP_USERS_LAST_ACTIVITY_DATE_VIEW,
    Permission.BATTLES_HISTORY_VIEW,
    Permission.CREDIT_SOFT_CURRENCY,
    Permission.CREDIT_HARD_CURRENCY,
    Permission.DEBIT_HARD_CURRENCY,
    Permission.ECONOMY_TXN_VIEW,
    Permission.ECONOMY_ITEMS_GRANT,
    Permission.ECONOMY_ITEMS_REVOKE,
    Permission.COMPLAINTS_VIEW,
    Permission.COMPLAINTS_DELETE,
    Permission.SELF_NICKNAME_EDIT,
  ],
};

export const applyRolePermissions = (admin: any, roles: any[] = []) => {
  const userRole = roles.find((role) => role.name === admin.role);
  admin.permissions = userRole?.permissions ?? rolePermissionsFallback[admin.role] ?? [];
  return admin;
};
